/* unplugin-vue-components disabled */import script from "./XForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./XForm.vue?vue&type=script&setup=true&lang=ts"

import "./XForm.vue?vue&type=style&index=0&id=c8099162&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8099162"]])

export default __exports__